import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import SimpleBar from 'simplebar-react'

import { SearchResultItem } from '../../types/searchResultItem'
import { Header } from '../Header'
import { OrganizationsSearchItem } from '../OrganizationsSearchItem'
import { ResultsFooter } from './ResultsFooter'
import * as Styled from './styles'

interface OrganizationsSearchResultsProps {
  organizationItems: SearchResultItem[]
  umbrellaItems: SearchResultItem[]
  searchValue?: string
  focusedId?: string
  onItemClick: (item: SearchResultItem) => void
}

export const OrganizationsSearchResults = ({
  focusedId,
  organizationItems,
  umbrellaItems,
  onItemClick,
  searchValue,
}: OrganizationsSearchResultsProps): ReactElement => {
  const { t } = useTranslation()
  return (
    <Styled.OrganizationsSearchResultsWrapper>
      <Styled.ResultsList>
        <SimpleBar>
          {umbrellaItems.length > 0 && (
            <>
              <Header title={t('organization_search.header.advisor_accounts')} count={umbrellaItems.length} />
              <div>
                {umbrellaItems.map((item) => (
                  <OrganizationsSearchItem
                    key={item.id}
                    item={item}
                    onClick={onItemClick}
                    searchValue={searchValue}
                    focusedId={focusedId}
                  />
                ))}
              </div>
            </>
          )}
          {organizationItems.length > 0 && (
            <>
              <Header title={t('organization_search.header.organizations')} count={organizationItems.length} />
              <div>
                {organizationItems.map((item) => (
                  <OrganizationsSearchItem
                    key={item.id}
                    item={item}
                    onClick={onItemClick}
                    searchValue={searchValue}
                    focusedId={focusedId}
                  />
                ))}
              </div>
            </>
          )}
        </SimpleBar>
      </Styled.ResultsList>
      <ResultsFooter />
    </Styled.OrganizationsSearchResultsWrapper>
  )
}
